export default "__VITE_ASSET__BJ66_ppq__"